module.exports = __webpack_public_path__ + "img/OneBangkokLogo.1460c4bc.png";